import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-[#0A0A0A] text-white pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* Main Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 pb-12 border-b border-white/10">

          {/* Col 1 - Brand */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3 mb-5">
              <img
                src="https://public.readdy.ai/ai/img_res/91970f4e-b5c6-4f7a-ae01-b1bdc8335b8e.png"
                alt="Logo HASPICA"
                className="h-8 w-auto object-contain brightness-0 invert"
              />
              <span className="font-bold text-lg tracking-widest" style={{ fontFamily: "'DM Sans', sans-serif" }}>
                HASPICA
              </span>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed max-w-xs">
              Studio de design indépendant à Bordeaux. Visuels clairs, modernes et efficaces pour vos projets professionnels et personnels.
            </p>
            <div className="mt-5 space-y-1 text-sm text-gray-500">
              <p>Patrik Haspica</p>
              <p>SIRET : 102 262 441 00011</p>
              <p>NAF : 74.10Z – Activités spécialisées de design</p>
            </div>
          </div>

          {/* Col 2 - Navigation */}
          <div>
            <h4 className="text-xs font-semibold tracking-widest text-gray-400 uppercase mb-5">
              <a href="#navigation">Navigation</a>
            </h4>
            <ul className="space-y-3">
              {[
                { label: 'Accueil', path: '/' },
                { label: 'À propos', path: '/a-propos' },
                { label: 'Contact', path: '/contact' },
                { label: 'Conditions générales', path: '/conditions-generales' },
                { label: 'Politique de confidentialité', path: '/politique-de-confidentialite' },
              ].map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm text-gray-400 hover:text-white transition-colors duration-200 cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Col 3 - Contact */}
          <div>
            <h4 className="text-xs font-semibold tracking-widest text-gray-400 uppercase mb-5">
              <a href="#contact-info">Contact</a>
            </h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2">
                <div className="w-4 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-map-pin-line text-gray-500 text-sm" />
                </div>
                <span className="text-sm text-gray-400">
                  12 Rue Judaïque<br />33000 Bordeaux<br />France
                </span>
              </li>
              <li className="flex items-center gap-2">
                <div className="w-4 h-5 flex items-center justify-center">
                  <i className="ri-phone-line text-gray-500 text-sm" />
                </div>
                <a
                  href="tel:+33607324193"
                  className="text-sm text-gray-400 hover:text-white transition-colors duration-200 cursor-pointer"
                >
                  +33 6 07 32 41 93
                </a>
              </li>
              <li className="flex items-center gap-2">
                <div className="w-4 h-5 flex items-center justify-center">
                  <i className="ri-mail-line text-gray-500 text-sm" />
                </div>
                <a
                  href="mailto:patrikhasp1ca@outlook.com"
                  className="text-sm text-gray-400 hover:text-white transition-colors duration-200 cursor-pointer"
                  rel="nofollow"
                >
                  patrikhasp1ca@outlook.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-6 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-gray-600">
          <p>&copy; {new Date().getFullYear()} HASPICA – Tous droits réservés</p>
          <div className="flex items-center gap-6">
            <Link to="/conditions-generales" className="hover:text-gray-400 transition-colors duration-200 cursor-pointer">
              Conditions générales
            </Link>
            <Link to="/politique-de-confidentialite" className="hover:text-gray-400 transition-colors duration-200 cursor-pointer">
              Confidentialité
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
